// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/iconfont.css'
import '@/assets/styles/main.scss'
import '@/assets/css/font-awesome.min.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

import 'vx-easyui/dist/themes/default/easyui.css';
import 'vx-easyui/dist/themes/icon.css';
import 'vx-easyui/dist/themes/vue.css';
import EasyUI from 'vx-easyui';
Vue.use(EasyUI);

import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)

/**权限指令**/
Vue.directive('has-permission', {
  inserted: function(el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el);
    }
  }
});

//权限检查方法
Vue.prototype.$_has = function(value) {
  let user = localStorage.getItem("access-user");
  if(user == undefined || user == null){
    return false;
  }
  let isExist=false;
  let jsonUser = JSON.parse(user);
  if (jsonUser && jsonUser.authorities){
    for(let i = 0; i < jsonUser.authorities.length; i++){
      if(jsonUser.authorities[i].authority === value){
        isExist = true;
        break;
      }
    }
  }
  return isExist;
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
});


// WEBPACK FOOTER //
// ./src/main.js